module.exports = __webpack_public_path__ + "img/19.26487207.png";